export default "__VITE_ASSET__PAjpMy$V__"